<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
export default {
  name: "AreaLine",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    },
    colorList: {
      type: Array,
      default() {
        return [
          "#0080ff",
          "#00cdff",
          "#00d8ae",
          "#a1e058",
          "#ffe05f",
          "#d97b81",
          "#ffb981"
        ];
      }
    },
    chartData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    if (this.chartData) {
      this.initChart();
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData() {
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.initChart();
    }
  },
  methods: {
    initChart() {
      // 拼装series
      var series = [];
      for (let i = 0; i < this.chartData.data.length; i++) {
        var temp = {
          name: this.chartData.data[i].legend,
          type: "line",
          yAxisIndex: 0,
          symbol: "none",
          itemStyle: {
            normal: {
              color: this.colorList[i],
              lineStyle: {
                color: this.colorList[i],
                opacity: 0.7
              },
              areaStyle: {
                color: this.colorList[i],
                opacity: 0.05
              }
            }
          },
          data: this.chartData.data[i].valueList
        };
        series.push(temp);
      }

      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        legend: {
          x: "center",
          y: "0",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: "#cbeeff",
            fontSize: 12
          },
          icon: "rect"
        },

        grid: {
          right: "5%",
          bottom: "16%",
          left: "3%",
          top: "40px",
          containLabel: true
        },
        dataZoom: [
          {
            backgroundColor: "rgba(47,69,84,0)",
            fillerColor: "rgba(36,118,157,0.4)",
            borderColor: "#142439",
            dataBackground: {
              lineStyle: {
                color: "#00cdff"
              },
              areaStyle: {
                color: "#1a4b67"
              }
            },
            textStyle: {
              color: "#cbeeff"
            },
            bottom: 0,
            left: "4%",
            right: "6%",
          }
        ],
        xAxis: [
          {
            type: "category",
            data: this.chartData.dateList,
            name: "",
            nameTextStyle: {
              color: "#d4ffff"
            },
            axisLine: {
              lineStyle: {
                color: "#142439"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#cbeeff",
                fontSize: 12
              }
              //interval:0,
              //rotate:30
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            nameTextStyle: {
              color: "#d4ffff"
            },
            position: "left",
            axisLine: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#142439",
                type: "dashed"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: "#cbeeff"
            }
          }
        ],
        series: series
      };
      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(option);
    }
  }
};
</script>
<style scoped lang="less">
.chart {
  width: 100% !important;
  height: 100% !important;
}
</style>
